import React, { useState } from 'react';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import { markStepComplete } from './StepGuard';
import { useAuth } from './StoreValue';
import { getAgentConfig } from '../utils/agentConfig';

const TermsAndConditions = () => {
    const [isChecked, setIsChecked] = useState(false);
    const navigate = useNavigate();
    const { agentIdVal } = useAuth();
    const { termsUrl, termsLabel } = getAgentConfig(agentIdVal);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isChecked) {
            markStepComplete('termsAndConditions');
            navigate('/eSignature');
        } else {
            alert('Please accept the terms and conditions.');
        }
    };

    return (
        <div>
          <Layout pageTitle="Terms and Conditions">
            <form onSubmit={handleSubmit}>
            <p>
                By using this service, you agree to our{' '}
                <a href={termsUrl} target="_blank" rel="noopener noreferrer">{termsLabel}</a>.
            </p>
            <label className='label_Control'>
                <input
                    type="checkbox"
                    checked={isChecked}
                    className='checkbox_Control'
                    onChange={handleCheckboxChange}
                />
                <span style={{ marginLeft: '8px' }}/>
                I have read and accept the Terms and Conditions.
            </label>
            <br />
            <div className="d-flex justify-content-center mt-3">
    <button type="submit" disabled={!isChecked} className="btn btn-success px-5" style={{ width: '370px' }}>
        Next
    </button>
        </div>
        </form>
        </Layout>
        </div>
    );
};

export default TermsAndConditions;
